export default "__VITE_ASSET__DhSfD0Uu__"